import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'pl',
  months: [
    'styczeń',
    'luty',
    'marzec',
    'kwiecień',
    'maj',
    'czerwiec',
    'lipiec',
    'sierpień',
    'wrzesień',
    'październik',
    'listopad',
    'grudzień',
  ],
  monthsShort: ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'],
  weekdays: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
  weekdaysMin: ['Nied', 'Pon', 'Wt', 'Śr', 'Czw', 'Pi', 'Sob'],
  weekdaysShort: ['niedz.', 'pon.', 'wt.', 'śr.', 'czw.', 'piąt.', 'sob.'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'D-MM-YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd, D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd, D MMMM HH:mm',
    l: 'D.M.YYYY',
    'l-Y': 'D.M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd, D MMM YYYY h:mm A',
    'llll-Y': 'ddd, D MMM h:mm A',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: '%s rok temu', few: '%s lata temu', many: '%s lat temu', other: '%s roku temu' },
    M: { one: '%s mies. temu', few: '%s mies. temu', many: '%s mies. temu', other: '%s mies. temu' },
    w: { one: '%s tydz. temu', few: '%s tyg. temu', many: '%s tyg. temu', other: '%s tyg. temu' },
    d: { one: '%s dzień temu', few: '%s dni temu', many: '%s dni temu', other: '%s dnia temu' },
    h: { one: '%s godz. temu', few: '%s godz. temu', many: '%s godz. temu', other: '%s godz. temu' },
    m: { one: '%s min temu', few: '%s min temu', many: '%s min temu', other: '%s min temu' },
    s: { one: '%s sek. temu', few: '%s sek. temu', many: '%s sek. temu', other: '%s sek. temu' },
  },
  future: {
    y: { one: 'za %s rok', few: 'za %s lata', many: 'za %s lat', other: 'za %s roku' },
    M: { one: 'za %s mies.', few: 'za %s mies.', many: 'za %s mies.', other: 'za %s mies.' },
    w: { one: 'za %s tydz.', few: 'za %s tyg.', many: 'za %s tyg.', other: 'za %s tyg.' },
    d: { one: 'za %s dzień', few: 'za %s dni', many: 'za %s dni', other: 'za %s dnia' },
    h: { one: 'za %s godz.', few: 'za %s godz.', many: 'za %s godz.', other: 'za %s godz.' },
    m: { one: 'za %s min', few: 'za %s min', many: 'za %s min', other: 'za %s min' },
    s: { one: 'za %s sek.', few: 'za %s sek.', many: 'za %s sek.', other: 'za %s sek.' },
  },
  abbr: {
    y: { one: '%s rok', few: '%s lata', many: '%s lat', other: '%s lat(-a)' },
    M: { one: '%s mies.', few: '%s mies.', many: '%s mies.', other: '%s mies.' },
    w: { one: '%s tydz.', few: '%s tyg.', many: '%s tyg.', other: '%s tyg.' },
    d: { one: '%s d.', few: '%s d.', many: '%s d.', other: '%s d.' },
    h: { one: '%s godz.', few: '%s godz.', many: '%s godz.', other: '%s godz.' },
    m: { one: '%s min', few: '%s min', many: '%s min', other: '%s min' },
    s: { one: '%s s', few: '%s s', many: '%s s', other: '%s s' },
  },
  justNow: 'Przed chwilą',
  yesterday: 'Wczoraj',
  today: 'Dziś',
  tomorrow: 'Jutro',
  weekStart: 1,
};
const localeName: LocaleName = 'pl';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
